import styled from 'styled-components';

export const PhoneNumber = styled.a`
  display: flex;
  gap: 5px;
  align-items: center;
  height: 60px;
  font-size: 15px;
  color: ${({ theme }) => theme.palette.primary.labels};

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.palette.primary.border};
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
`;
